module.exports = __webpack_public_path__ + "img/b6b965c.jpg";